import React from 'react';

class Acordion extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            activeTitle:props.data[0].title
        }
    }

    onClick=(item)=>{
        this.setState({
          activeTitle: item.title,
        });
    }
  render() {
    return (
      <ul className="accordion accordion-1 accordion--oneopen">
        {this.props.data.map((item)=>{
            return (
            <li className={item.title == this.state.activeTitle?"active":""} onClick={()=>this.onClick(item)}>
                <div className="accordion__title">
                    <span className="h5">{item.title}</span>
                </div>
                <div className="accordion__content">
                    <p className="lead">
                        {item.description}
                    </p>
                </div>
            </li>
            )
        })}
      </ul>
    )
  }
}

export default Acordion;